<template>
    <div class="row p-0 autocomplete-group" v-if="items.length" :class="filters.length <= 1 ? 'short' : ''">
        <ul class="autocomplete-list list-group p-0 list2">
            <li class="list-group-item d-flex align-items-center">
                <div v-if="page > 1" @click="scrollBackward" class="p-0 w-25 text-uppercase more d-flex align-items-center">
                    <img src="@/assets/svg/arrow-up-12B47D.svg">
                    <span class="pl-2">Terug</span>
                </div>
                <div v-else class="p-0 w-25 text-uppercase more d-flex align-items-center">
                    <span class="pl-2">&nbsp;</span>
                </div>
            </li>
            <li
                class="list-group-item"
                v-for="item in loadServices"
                :key="item.id"
                @click="selectService(item)"
            >
                <span style="display:inline-block;" class="key w-25">{{ item.code }}</span>
                <p style="display:inline-block;" class="m-0">{{ item.title_NL }}</p>
            </li>
            <li class="list-group-item d-flex align-items-center">
                <div v-if="page < pageTotal && pageTotal" @click="scrollForward" class="p-0 w-25 text-uppercase more d-flex align-items-center">
                    <img src="@/assets/svg/arrow-down-12B47D.svg">
                    <span class="pl-2" >verder</span>
                </div>
                <div class="p-0 w-25 text-uppercase add d-flex align-items-center pl-2">
                    <img src="@/assets/svg/plus008CDD.svg">
                    <span class="pl-2">TOEVOEGEN</span>
                </div>
            </li>
        </ul>
        <ul class="autocomplete-list list-group p-0 additional-options" v-if="filters.length > 1">
            <li
                class="list-group-item d-flex align-items-center justify-content-between"
                v-for="filter in filters"
                :key="filter.id"
                @click="filterService(filter.id)"
                :class="{ active : filterId === filter.id}"
            >
                <span>{{ filter.name_NL }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import Service from '@/services/hatsApi/Service'

export default {
  props: {
    item: {
      type: Object,
      required: false
    },
    searchProperty: {
      default: 'title_NL',
      type: String,
      required: false
    },
    servicesPerPage: {
      default: 0,
      type: Number,
      required: false
    },
    filters: {
      type: Array,
      required: false
    },
    filterType: {
      default: 'service',
      type: String,
      required: false
    }
  },
  data () {
    return {
      items: [],
      filterId: null,
      page: 1,
      amount: this.servicesPerPage || (this.filters.length - 2),
      pageTotal: null
    }
  },
  computed: {
    loadServices () {
      let loadedServices = []
      if (this.items.length) {
        loadedServices = this.items
      }
      return loadedServices
    }
  },
  watch: {
    item: {
      handler (newVal, oldVal) {
        this.page = 1
        this.debouncedSearch()
      },
      deep: true
    }
  },
  methods: {
    selectService (service) {
      this.$emit('update:item', service)
    },
    scrollBackward () {
      if (this.page < 1) {
        this.page = 1
      } else {
        this.page -= 1
      }
      this.autoComplete()
    },
    scrollForward () {
      this.page += 1
      this.autoComplete()
    },
    filterService (id) {
      this.page = 1
      this.filterId = id
      this.autoComplete()
    },
    async autoComplete () {
      let params = []
      // Search keywords
      if (this.item[this.searchProperty]) {
        if (this.searchProperty === 'title_NL') {
          params.push({
            property: 'queryTitle',
            value: this.item[this.searchProperty]
          })
        } else {
          params.push({
            property: this.searchProperty,
            value: this.item[this.searchProperty]
          })
        }
      }
      // Filtered search
      if (this.filterId) {
        if (this.filterType === 'category') {
          params.push({
            property: 'serviceCategoryId',
            value: this.filterId
          })
        }
        if (this.filterType === 'service') {
          params.push({
            property: 'serviceTypeId',
            value: this.filterId
          })
        }
      } else { // Non filter search
        // Get the service type prebuilt_trip
        const prebuildTrip = this.$store.getters.prebuildTrip
        if (this.filterType === 'category') {
          if (prebuildTrip) {
            params.push({
              property: 'serviceTypeId',
              value: prebuildTrip.id
            })
          }
        } else {
          const serviceTypeList = []
          // Pass all non PREBUILD_TRIP service types as the all service types search
          this.$store.getters.serviceTypes.forEach((serviceType) => {
            if (serviceType && prebuildTrip && serviceType.id !== prebuildTrip.id) {
              serviceTypeList.push(serviceType.id)
            }
          })
          params.push({
            property: 'serviceTypeId',
            value: serviceTypeList.join(',')
          })
        }
      }
      const response = await Service.getServices(params, this.amount, this.page)
      if (response.data.data.length) {
        this.items = response.data.data
        this.pageTotal = response.data.pages
      } else {
        this.items = [{title_NL: 'no results'}]
        this.pageTotal = 0
      }
    }
  },
  created () {
    if (this.filters.length === 1) {
      this.filterId = this.filters[0].id
    }
    this.debouncedSearch = this.$_.debounce(this.autoComplete, 500)
    this.autoComplete()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/PaginatedDropDown.vue